import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ip} from '../../api/customer/ip.api';
import {IpRes} from '../../models/customer/responses/ip-res';

@Injectable({
  providedIn: 'root',
})
export class IpService {
  constructor(private http: HttpClient) {}

  getIpAddress(): Observable<IpRes> {
    return this.http.get<IpRes>(`${ip.api}?format=json`);
  }
}
